import { IkeToken, IkeUserRole } from '@ikegps/core-api';
import { CaptureProviderHelpers, type CollectionModelFieldImage } from '@ikegps/core-shared';
import { addStyles, DefaultTheme } from '../../../components/theme';
import type { MithrilVNode } from '../../../mithril';
import { m } from '../../../mithril';
import { Services } from '../../../services';
import { CaptureThumbnail, type CaptureThumbnailCtx } from '../../capture.thumbnail/capture.thumbnail';
import type { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const CSS = {
	capture: 'c-Image__capture',
};

addStyles({
	[CSS.capture]: {
		padding: DefaultTheme.space(1),
	},
});

export const ImageFieldView: CollectionFieldView<CollectionModelFieldImage> = {
	viewInline(field: CollectionModelFieldImage): string {
		const captures = field.getCaptures();
		if (captures.length > 0) {
			return String(captures.length);
		}
		return '';
	},

	hasDetail(field: CollectionModelFieldImage) {
		return field.getCaptures().length > 0;
	},

	viewDetail(field: CollectionModelFieldImage): MithrilVNode {
		const ctx: CaptureThumbnailCtx = { className: CSS.capture };
		const collection = field.collection;
		const captureChildren: MithrilVNode[] = [];
		for (const capture of field.getCaptures()) {
			ctx.title = Services.DateTime.formatDateTime(capture.collectedAt.iso);
			captureChildren.push(CaptureThumbnail.view(collection, capture, ctx));
		}

		return m.fragment({}, captureChildren);
	},

	viewEdit(field: CollectionModelFieldImage, state: CollectionEditCtrl): MithrilVNode | string {
		return ImageFieldView.viewInline(field, state);
	},

	hasClear(field: CollectionModelFieldImage) {
		return false;
	},

	canUpload(field: CollectionModelFieldImage) {
		const currentUser = Services.User.current;
		const userProfile = currentUser ? Services.UserProfile.get(currentUser.objectId) : null;
		const hasPreviousCaptures = CaptureProviderHelpers.getCaptureIds(field.collection).length !== 0;
		return (
			hasPreviousCaptures &&
			Services.Token.has(IkeToken.FEATURE_OFFICE_IMAGE_UPLOAD) &&
			Services.UserProfile.isOneOf(userProfile, [
				IkeUserRole.USER,
				IkeUserRole.EDITOR,
				IkeUserRole.ROOT,
				IkeUserRole.DATA_ADMIN,
			])
		);
	},
};
